const copilot20 = {
    svg: '<svg style="width:1.25rem; height:1.25rem;" viewBox="0 0 200 200"><rect width="100" height="200"/></svg>',
};

export { copilot20 as default };
